var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-menu-item',{attrs:{"index":_vm.menu.path || _vm.uniqueId}},[_c('span',{attrs:{"slot":"title"},slot:"title"},[_vm._v(_vm._s(_vm.menu.title || '未命名菜单'))])])
}
var staticRenderFns = []

export { render, staticRenderFns }